import * as React from 'react';

import { getTranslation } from '@base/utils';

import s from './MainMenuAuth.scss';

interface IMainMenuAuthProps {
	loginUrl: string;
	registrationUrl: string;
}

export const MainMenuAuth = (props: IMainMenuAuthProps) => {
	const { loginUrl, registrationUrl } = props;
	const t = getTranslation('components.MainMenu');

	return <div className={s.block}>
		<a href={loginUrl} className={s.loginButton}>{t('login')}</a>
		<a href={registrationUrl} className={s.registerButton}>{t('registration')}</a>
	</div>;
};
